import React, { memo, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import MessagesList from './MessagesList';
import { setEditableMessage } from '../../../redux/scout/scoutReducer';
import MessageCard from '../message-card/MessageCard';

import scss from './MessagesList.module.scss';

const MessagesOutput = ({
  bindNextAction,
  onSearch,
  onLike,
  onSelect,
  onDelete,
  onRestore,
  onSaveMessage,
  getMessageLogs,
  maxHeight,
}) => {
  const { id } = useParams();
  const tableWrapperRef = useRef(null);

  const { messagesContent, isMessagesLoading, tableSettings, isGenerating } = useSelector((state) => state.scout);

  const handleUpdateTableData = () => {
    onSearch({ id });
  };

  useEffect(() => {
    if (onSearch) {
      onSearch({ id });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableSettings]);

  return (
    <div className={scss.tableWrapper} ref={tableWrapperRef}>
      <MessagesList
        content={messagesContent}
        isLoading={isMessagesLoading || isGenerating}
        bindNextAction={bindNextAction}
        onTableUpdate={handleUpdateTableData}
        onLike={onLike}
        onSelect={onSelect}
        onDelete={onDelete}
        onRestore={onRestore}
        onSaveMessage={onSaveMessage}
        getMessageLogs={getMessageLogs}
        maxHeight={maxHeight}
        setEditableMessage={setEditableMessage}
        MessageCard={MessageCard}
        logsSelector={(state) => state.scout}
      />
    </div>
  );
};

export default memo(MessagesOutput);
